import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { authClient } from "../lib/auth-client";

interface RequireSessionProps {
  children: ReactNode;
}

export function RequireSession({ children }: RequireSessionProps) {
  const { data: session, isPending } = authClient.useSession();

  if (isPending) {
    return (
      <section className="relative overflow-hidden bg-[radial-gradient(circle_at_top_left,_rgba(14,165,233,0.16),_transparent_32%),linear-gradient(180deg,#f8fafc_0%,#ffffff_38%,#f8fafc_100%)] py-12 sm:py-16">
        <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(rgba(148,163,184,0.06)_1px,transparent_1px),linear-gradient(90deg,rgba(148,163,184,0.06)_1px,transparent_1px)] bg-[size:88px_88px] [mask-image:linear-gradient(180deg,white,rgba(255,255,255,0.2))]" />
        <div className="relative mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <div className="rounded-md border border-slate-200/80 bg-white/90 px-6 py-16 text-center shadow-[0_24px_64px_rgba(15,23,42,0.07)] backdrop-blur">
            <div className="mx-auto h-8 w-8 animate-spin rounded-full border-4 border-slate-200 border-t-sky-600" />
            <p className="mt-4 text-sm font-medium text-slate-500">Checking your account...</p>
          </div>
        </div>
      </section>
    );
  }

  if (!session) {
    return <Navigate to="/auth/login" replace />;
  }

  return <>{children}</>;
}
